<template>
  <div>
    <div class="cui__utils__heading">
      <strong>Brzo kreiranje novog zahtjeva</strong>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-lg-4">
            <kit-list-5 :show="1" />
          </div>
          <div class="col-lg-4">
            <kit-list-5 :show="2" />
          </div>
          <div class="col-lg-4">
            <kit-list-5 :show="3" />
          </div>
        </div>
      </div>
    </div>
    <div class="cui__utils__heading">
      <strong>Pregled zahtjeva</strong>
    </div>
    <div class="row">
      <div class="col-md-8 col-sm-12">
        <div class="card">
          <div class="card-header card-header-flex">
            <div class="d-flex flex-column pt-3 pb-3 mr-auto">
              <div class="cui__utils__heading mb-0">
                <strong>Moji zahtjevi</strong>
              </div>
              <div class="text-muted">Zahtjevi za odsustvo koji čekaju odobrenje</div>
            </div>
            <div class="d-flex flex-column p-3">
              <a-button class="ml-3">Pogledaj sve zahtjeve</a-button>
            </div>
          </div>
          <div class="card-body">
            <a-table :columns="tableColumns" :dataSource="tableData" :pagination="false">
              <span
                slot="status"
                slot-scope="title"
                :class="[title === 'Odobren' ? 'font-size-12 badge badge-success' : 'font-size-12 badge badge-default']"
              >{{title}}</span>
            </a-table>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-sm-12">
        <div class="card">
          <div class="card-header">
            <div class="cui__utils__heading mb-0">
              <strong>Predstojeći praznici</strong>
            </div>
            <div class="text-muted">Potencijalo odsustvo većeg broja zaposlenih</div>
          </div>
          <div class="card-body">
            <kit-list-19v1/>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <div class="cui__utils__heading mb-0">
              <strong>Moji ugovori</strong>
            </div>
            <div class="text-muted">Ugovori koji su u sistemu dostupni</div>
          </div>
          <div class="card-body">
            <a-table :columns="tableColumns2" :dataSource="tableData2" :pagination="false">
              <span slot="action">
                <a href="javascript: void(0);" class="btn btn-sm btn-primary mr-2">
                  <i class="fe fe-eye mr-2" />
                  Pregledaj
                </a>
                <a href="javascript: void(0);" class="btn btn-sm btn-warning">
                  <small>
                    <i class="fe fe-clock mr-2" />
                  </small>
                  Odloži
                </a>
              </span>
            </a-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import CuiChart4 from '@/components/kit/widgets/Charts/4'
// import CuiChart4v1 from '@/components/kit/widgets/Charts/4v1'
// import CuiChart4v2 from '@/components/kit/widgets/Charts/4v2'
// import CuiChart4v3 from '@/components/kit/widgets/Charts/4v3'
// import CuiChart11 from '@/components/kit/widgets/Charts/11'
// import CuiChart11v1 from '@/components/kit/widgets/Charts/11v1'
// import CuiChart11v2 from '@/components/kit/widgets/Charts/11v2'
// import CuiGeneral17 from '@/components/kit/widgets/General/17'
// import CuiGeneral17v1 from '@/components/kit/widgets/General/17v1'
// import CuiGeneral17v2 from '@/components/kit/widgets/General/17v2'
// import CuiGeneral18 from '@/components/kit/widgets/General/18'
// import CuiGeneral18v1 from '@/components/kit/widgets/General/18v1'
// import CuiGeneral6 from '@/components/kit/widgets/General/6'
// import CuiGeneral6v1 from '@/components/kit/widgets/General/6v1'
import KitList19v1 from '@/components/kit/widgets/Lists/19v1/index'
import KitList5 from '@/components/kit/widgets/Lists/5/index'

import data from './data.json'

const tableColumns = [
  {
    title: 'Tip zahtjeva',
    dataIndex: 'type',
    key: 'type',
  },
  {
    title: 'Datum podnošenja',
    dataIndex: 'date',
    key: 'date',
  },
  {
    title: 'Dani odsustva',
    dataIndex: 'age',
    key: 'age',
    sorter: (a, b) => a.age - b.age,
  },
  {
    title: 'Kontrola',
    dataIndex: 'controller',
    key: 'controller',
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    scopedSlots: { customRender: 'status' },
  },
]

const tableColumns2 = [
  {
    title: 'Ime',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Pozicija',
    dataIndex: 'position',
    key: 'position',
  },
  {
    title: 'Tip dokumenta',
    dataIndex: 'age',
    key: 'age',
    sorter: (a, b) => a.age - b.age,
  },
  {
    title: 'Dokument',
    dataIndex: 'office',
    key: 'office',
  },
  {
    title: 'Ističe za',
    dataIndex: 'date',
    key: 'date',
  },
  {
    title: 'Opcije',
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  components: {
    // CuiChart4,
    // CuiChart4v1,
    // CuiChart4v2,
    // CuiChart4v3,
    // CuiChart11,
    // CuiChart11v1,
    // CuiChart11v2,
    // CuiGeneral17,
    // CuiGeneral17v1,
    // CuiGeneral17v2,
    // CuiGeneral18,
    // CuiGeneral18v1,
    // CuiGeneral6,
    // CuiGeneral6v1,
    KitList19v1,
    KitList5,
  },
  data() {
    return {
      tableData: data.tableData,
      tableColumns,
      tableColumns2,
      tableData2: data.tableData2,
    }
  },

}
</script>
